export default "__VITE_PUBLIC_ASSET__1eee7fba__"